import { createSlice } from "@reduxjs/toolkit";
import { savePrescription } from "../../reducer/savePrescription/savePrescriptionReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const savePrescriptionSlice = createSlice({
  name: "savePrescription",
  initialState,
  reducers: {
    resetSavePrescription: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(savePrescription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePrescription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(savePrescription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetSavePrescription } = savePrescriptionSlice.actions;

export default savePrescriptionSlice.reducer;
